/* eslint-disable import/no-extraneous-dependencies */
import { broadcast } from '@finn-no/common-browserbundle';
import { collectWhenLoaded } from '@finn-no/navigation-timing';
import pulse from '@finn-no/pulse-sdk';
import cookieMatch from '@finn-no/distribution-cookiematch';
import * as braze from '@braze/web-sdk';
import controllerist from './controllerist';

function getEventTargetOptions(element) {
    const options = { id: element.getAttribute('href') };

    if (element.hasAttribute('data-page-link')) {
        options.type = 'Page';
    } else if (element.hasAttribute('data-external-link')) {
        options.type = 'ExternalContent';
        options.name = 'Go to webpage';
        options.provider = element.getAttribute('data-icon-name');
        options.referralCommission = false;
    } else {
        options.type = 'MarketFrontpage';
    }

    return options;
}

function addTrackingToMarketLinks() {
    document
        .querySelectorAll('[data-markets-pulse-wrapper] a')
        .forEach((element) => {
            const eventTargetOptions = getEventTargetOptions(element);
            const iconName = element.getAttribute('data-icon-name');

            element.addEventListener('click', () => {
                pulse.trackEvent({
                    type: 'Click',
                    intent: 'Open',
                    name: `Open ${iconName}`,
                    object: {
                        type: 'UIElement',
                        elementType: 'Market icon',
                    },
                    target: eventTargetOptions,
                });
            });
        });
}

function addTjtBannerTracking() {
    const tjtLink = document.querySelector('[data-tjt-banner-link]');

    tjtLink.addEventListener('click', () => {
        pulse.trackEvent({
            type: 'Click',
            intent: 'Open',
            name: 'Transaction journey torget',
            object: {
                type: 'UIElement',
                elementType: 'Banner',
                position: 'Frontpage',
            },
            target: {
                id: tjtLink.getAttribute('href'),
                type: 'Article',
                pageType: 'ad_insertion',
                name: 'Fiks ferdig',
            },
        });
    });
}

function performanceController() {
    const { host } = window.location;
    if (
        host.indexOf('dev.finn.no') === -1 &&
        host.indexOf('local.finn.no') === -1
    ) {
        collectWhenLoaded(
            'frontpage-podium',
            'https://www.finn.no/clientstats.html',
        );
    }
}

function addBraze() {
    const { brazeApiKey, brazeEndpointUrl, useBraze } =
        document.querySelector('#frontpage-content').dataset;
    if (useBraze !== 'true') return;
    braze.initialize(brazeApiKey, {
        baseUrl: brazeEndpointUrl,
    });
    braze.automaticallyShowInAppMessages();
    braze.changeUser(window.finnUserId);
    braze.openSession();
}

function main() {
    const c = controllerist();
    c.register('performance-timing', performanceController);

    c.run(document);

    cookieMatch({ source: 'frontpage' });
    setTimeout(() => {
        broadcast();
    }, 0);

    if (navigator.serviceWorker) {
        navigator.serviceWorker.register('/sw.js').catch(() => {});
    }

    window.addEventListener('DOMContentLoaded', () => {
        pulse.trackPageView({
            object: {
                type: 'Frontpage',
            },
            vertical: {
                name: 'common_pages',
            },
        });

        addTjtBannerTracking();
        addTrackingToMarketLinks();
        addBraze();
    });
}

main();
